/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react';
import queryString from 'query-string';
import { Container, Row, Col } from 'reactstrap'

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import LoginForm from './LoginForm';
import textByCountry from './textByCountry.json';

class Login extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    this.country = this.parameters.country ? this.parameters.country : 'PE';
    this.showCountries = !this.parameters.country;
    this.text = textByCountry[this.country];
    this.logo = require(`./img/${this.text.logoSrc}`);
    props.changeDefaultLocale('es');
  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.body.className = 'gvpprod-body';
    document.title = 'Página de autenticación';
  }

  render() {
    const { translate } = this.props;

    return (
      <div className="gvpprod">
        <Container className="themed-container" fluid="xl">
          <Row>
            <Col sm="4"></Col>
            <Col sm="4" className="text-center">
              <div className="container-login-gvp">
                <div className="brand-name">
                  <img src={this.logo} id="logo" alt="logo" />
                </div>
                {
                  this.text.header ?
                    <p className="headerText" id="subtitle">{this.text.header}</p>
                    : null
                }
                {
                  this.text.h1 ?
                    <h1 className="title-gvp mt-2" id="title">{this.text.h1}</h1>
                    : null
                }
                {
                  this._validateParams()
                    ? <LoginForm
                      api={this.api}
                      location={this.props.location}
                      text={this.text}
                      showCountries={this.showCountries}
                    />
                    : <RequestLoginErrorMessage
                      onlyMessage={true}
                      message={translate('RequestLoginErrorMessage')}
                    />
                }
              </div>
            </Col>
            <Col sm="4"></Col>
          </Row>
        </Container>

      </div>
    );
  }
}

export default WithLocalize(Login);
